import posNotificationInstance from '../instance'

const deleteWatch = (watchId) => {
	return posNotificationInstance.delete(`watches/${watchId}`)
}

export default deleteWatch
